import SkapaElement from "./src/SkapaElement.js";
var skapa_element_default = SkapaElement;
export {
  SkapaElement,
  skapa_element_default as default
};
